export default __webpack_public_path__ + "static/media/refah.98115260.png";